import { useMemo } from 'react';
import { useGlobalState } from '../global/context/global-context';
import { IMenuResponse } from '../../model/base/response/menu-response';

const byOrder = (a: { orderNumber?: number }, b: { orderNumber?: number }) => (a.orderNumber || 0) - (b.orderNumber || 0);

const withPublishedItems = (menu: IMenuResponse): IMenuResponse => ({
    ...menu,
    items: menu.items?.filter(item => item.isPublished !== false).sort(byOrder) || []
});

/**
 * menus: menus do "Acesso a Informações" (sem chave): os de link direto e os que têm itens publicados.
 * mainMenus: menus fixos da barra principal (com chave), na ordem definida pela entidade no APM;
 * vazio quando a entidade ainda não materializou os fixos (a barra usa a estrutura padrão).
 */
export const useMenusData = () => {
    const { applicationData } = useGlobalState();
    const allMenus = applicationData?.menus;

    const menus = useMemo(() => (allMenus || [])
        .filter(menu => !menu.key)
        .map(withPublishedItems)
        .filter(menu => !!menu.url || (menu.items && menu.items.length > 0))
        .sort(byOrder), [allMenus]);

    const mainMenus = useMemo(() => (allMenus || [])
        .filter(menu => !!menu.key)
        .map(withPublishedItems)
        .sort(byOrder), [allMenus]);

    return { menus, mainMenus };
};
